import { Evaluation } from 'src/app/alerts/models/alert.interface';

export interface EventContent {
  id_event: string;
  name_event_long: string;
  name_event_short: string;
  name_unit: string;
  name_driver: string;
  longitude_event: number;
  latitude_event: number;
  url_google_maps: string;
  date_event: string;
  speed_unit: number;
  limit_speed_unit: number;
  geocerca: string;
  reference_event: string;
  type_event: string;
  time_limit_infraction: number;
  componentRef: any;
  luminaria: string;
  last_maintenance: string;
  hours_passed: number;
  hours_remaining: number;
  odometer: number;
  rpm: number;
  time_tolerance: number;
  voltage: number;
  time_estadia: number;
  alcohol_level: number;
  server_date: string;
  evaluations: Evaluation;
  evaluations_criteria_filter: OptionDropdown[];
  operators: OptionDropdown[];
  hasEventForm: boolean;
  slug_event? : string
}

export interface OptionDropdown {
  label: string;
  items: ItemOption[];
}

export interface ItemOption {
  label: string;
  value: string;
}

export interface ErrorMessage {
  status: boolean;
  message: string;
}

export interface FormValidationResult {
  isValid: boolean;
  errors: {
    criteria?: string;
    url?: string;
    calification?: string;
    observation?: string;
    operator?: string;
  };
}

export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'Este campo es requerido',
  INVALID_URL: 'La URL ingresada no es válida',
  INVALID_CALIFICATION: 'La calificación debe estar entre 0 y 100',
  MIN_LENGTH: (field: string, length: number) =>
    `${field} debe tener al menos ${length} caracteres`,
} as const;

export interface ValueInputsDisabled {
  criteria_name: string;
  url_video: string;
  calification: number;
  observation: string;
  operator_name: string;
  comunication: any;
}
